export const tifMimeTypes = ["image/tiff"];
